import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useAnimation } from 'framer-motion'
import { useInView } from "react-intersection-observer"
import { Theme } from 'theme'
import { LendingUnits } from 'components/Landing/enums'

import {
  Wrapper,
  Title,
  Description,
  Background,
  BackgroundItem,
  ItemWrapper,
  Fade
} from './styled'

// images
import BackgroundImg from './assets/background.webp'
import BackgroundItemImg from './assets/item.webp'

// components
import Form from './Form'


export default function RegisterScreen() {

  const { t, i18n } = useTranslation()

  const control = useAnimation()
  const [ref, inView] = useInView({
    triggerOnce: true,
    rootMargin: LendingUnits.animationShowFooter
  })

  useEffect(() => {
    if (inView) {
      control.start("end");
    }
  }, [control, inView]);

  const infoAnimation = { ...Theme.motion.default, delay: 0.1 }

  return (

    <Wrapper
      variants={Theme.motion.jumpBottom} initial="start" animate={control} transition={infoAnimation}
      ref={ref}
    >
      <Title>{t("landing.footer.title")}</Title>
      <Description>{t("landing.footer.description")}</Description>
      <ItemWrapper>
        <BackgroundItem src={BackgroundItemImg} />
      </ItemWrapper>
      <Fade />

      <Form />

      <Background src={BackgroundImg} />
    </Wrapper>

  )

}